
type TloginData = Record<'pid' | 'gid' | 'mid' | 'p_mid' | 'os' | 'device_id' | 'uid' | 'uname' | 'vname' | 'access_token', string>


interface promiseResult {
    code: number
    data?: any
    msg: string
}

// 扩展 Window 接口以支持第三方 SDK
declare global {
    interface Window {
        FB: any
        google: any
        AppleID: any
    }
}


import { computed } from 'vue'

import index from './Index.vue'
import useShowComponent from '@/hooks/uesShowComponent'
import { getRawUrlObj } from '@/common/ts/utils'
import { useUserStore, useComDataStore } from '@/store'
import i18n from '@/i18n';

import { showToast } from '@/components/Toast';
import http from '@/http'
import { addSign } from '@/http/addSign'



const urlObj = getRawUrlObj()

const { show, hide } = useShowComponent('login', index)
const showLogin = show
const hideLogin = hide





const loginSuccess = (res: TloginData) => {
    const { tokenAction, userInfoAction } = useUserStore()
    const { comReqDataAction } =  useComDataStore()
    tokenAction.save(res.access_token)
    comReqDataAction.save({
        pid: Number(res.pid),
        gid: Number(res.gid)
    })
    userInfoAction.save({
        // pid: res.pid,
        // gid: res.gid,
        os: res.os,
        device_id: res.device_id,
        uid: res.uid,
        uname: res.uname,
        vname: res.vname,

        serverId: '',
        serverName: '',
        roleId: '',
        roleName: '',
        roleLevel: '',
    })

    showToast({
        content: (i18n.global as any).t('toast.loginSuccess'),
        type: 'none',
    })

    hideLogin()
}


const logout = () => {
    const { tokenAction, userInfoAction } = useUserStore()
    tokenAction.clear()
    userInfoAction.clear()
    window.location.reload()
}


let _store: ReturnType<typeof useUserStore> | null = null
const getStore = () => {
    if (!_store) {
        _store = useUserStore()
    }
    return _store
}
// const initData = computed(() => getComDataStore().initDataAction.data)

// const googleClientID = computed(() => initData.value.social_param.google_client_id)
// const facebookAppID = computed(() => initData.value.social_param.facebook_appid)
// const appleClientID = computed(() => initData.value.social_param.apple_client_id)


const loginWithFacebook = () => {
    const facebookAppID = computed(() => getStore().socialParam.facebook_appid)
    // Facebook 登录逻辑优化
    return new Promise<promiseResult>((resolve) => {
        const facebookLogin = () => {
            window.FB.login((response: { authResponse: { accessToken: string, userID: string, signedRequest: string }, status: string }) => {
                if (response.status === 'connected') {
                    // console.log('Facebook登录成功', response);
                    http.socialLogin(addSign({
                        type: 3,
                        partner_data: JSON.stringify({
                            input_token: response.authResponse.accessToken,
                            signedRequest: response.authResponse.signedRequest
                        })
                    })).then((res: any) => {
                        if (res.code === 200) {
                            loginSuccess(res.data)
                            resolve({
                                code: 200,
                                data: response,
                                msg: 'Facebook登录成功'
                            })
                        } else {
                            resolve({
                                code: res.code,
                                msg: res.msg || 'Facebook登录失败'
                            })
                        }
                    })
                } else {
                    // 登录失败
                    console.log('Facebook登录失败', response);
                    resolve({
                        code: 400,
                        msg: 'Facebook登录失败'
                    })
                }
            });
        }

        if (!window.FB) {
            const script = document.createElement('script');
            script.src = `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v1.0&appId=${facebookAppID.value}&autoLogAppEvents=1`;
            script.async = true;
            script.defer = true;
            script.crossOrigin = 'anonymous';
            script.onload = () => facebookLogin();
            document.head.appendChild(script);
        } else {
            facebookLogin();
        }
    })
}



const loginWithGoogle = () => {
    const googleClientID = computed(() => getStore().socialParam.google_client_id)
    return new Promise<promiseResult>((resolve) => {
        const handleGoogleSignIn = async (response: { clientId: string, client_id: string, credential: string, select_by: string }) => {
            // 处理Google登录成功的响应
            console.log('Google登录成功', response);
            const res = await http.socialLogin(addSign({
                type: 4,
                partner_data: JSON.stringify({
                    id_token: response.credential
                })
            }))
            if (res.code === 200) {
                loginSuccess(res.data)
                resolve({
                    code: 200,
                    data: response,
                    msg: 'Google登录成功'
                })
            } else {
                resolve({
                    code: res.code,
                    msg: res.msg || 'Google登录失败'
                })
            }
        };
        const handleGoogleSignInCancel = () => {
            // 处理Google登录取消
            console.log('Google登录被取消');
            resolve({
                code: 400,
                msg: 'Google登录被取消'
            })
        };
        const initializeGoogleSignIn = (client_id: string) => {
            window.google.accounts.id.initialize({
                client_id,
                cancel_on_tap_outside: true,
                auto_select: false,
                callback: handleGoogleSignIn,
                cancel: handleGoogleSignInCancel,
            });
            // 渲染“使用 Google 帐号登录”按钮（如无按钮则动态创建）
            let btn = document.getElementById('google-login-button');
            if (!btn) {
                btn = document.createElement('div');
                btn.id = 'google-login-button';
                btn.style.display = 'none';
                document.body.appendChild(btn);
            }
            window.google.accounts.id.renderButton(
                btn,
                {
                    theme: 'outline',
                    size: 'large',
                    text: 'login_with',
                    shape: 'rectangular',
                },
            );
            document.cookie = `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
            window.google.accounts.id.prompt();
        };
        if (!window.google) {
            const script = document.createElement('script');
            script.src = 'https://accounts.google.com/gsi/client';
            script.async = true;
            script.onload = () => initializeGoogleSignIn(googleClientID.value);
            document.head.appendChild(script);
        } else {
            initializeGoogleSignIn(googleClientID.value);
        }
    })
}


const parseJwt = (token: string) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
    );
    return JSON.parse(jsonPayload);
}
const loginWithApple = () => {
    const appleClientID = computed(() => getStore().socialParam.apple_client_id)
    return new Promise<promiseResult>((resolve) => {
        const appleLogin = () => {
            window.AppleID.auth.signIn().then(async (response: any) => {
                console.log('Apple登录成功', response);
                // Apple 返回 id_token 和 user 信息
                const { id_token } = response.authorization || {};
                const payload = parseJwt(id_token);
                const sub = payload.sub;
                const res = await http.socialLogin(addSign({
                    type: 5,
                    partner_data: JSON.stringify({
                        token: id_token,
                        sub
                    })
                }))
                if (res.code === 200) {
                    loginSuccess(res.data)
                    resolve({
                        code: 200,
                        data: response,
                        msg: 'Apple登录成功'
                    })
                } else {
                    resolve({
                        code: res.code,
                        msg: res.msg || 'Apple登录失败'
                    })
                }
            }).catch(() => {
                resolve({
                    code: 400,
                    msg: 'Apple登录失败'
                })
            })
        }
        if (!window.AppleID) {
            const script = document.createElement('script');
            script.src = `https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js`;
            script.type = 'text/javascript';
            script.onload = () => {
                window.AppleID.auth.init({
                    clientId: appleClientID.value,
                    scope: 'email',
                    redirectURI: window.location.origin,
                    state: 'DE',
                    usePopup: true
                });
                appleLogin();
            }
            document.head.appendChild(script);
        } else {
            appleLogin();
        }
    })
}







export {
    loginSuccess,
    logout,

    loginWithFacebook,
    loginWithGoogle,
    loginWithApple,

    showLogin,
    hideLogin,
}



